export const youtubeConfig = {
	maxResults: 6,
};